import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'

export interface CodeText {
  code: string
  text: string
}

export interface LoanRange {
  fromAmount: number
  toAmount: number
  minTermMonths: number
  maxTermMonths: number
  terms: number[]
}

export interface Codetable {
  maritalStatuses: Array<CodeText>
  countries: Array<CodeText>
  employmentTypes: Array<CodeText>
  education: Array<CodeText>
  housingTypes: Array<CodeText>
  occupationsByEmploymentType: Record<string, Array<CodeText>>
  stayDurations: Array<CodeText>
  loanRanges: Array<LoanRange>
}

export type CodeTableState = ImmutableGenericType<Codetable>

// @ts-ignore
export const initialState: CodeTableState = Immutable({
  maritalStatuses: [],
  countries: [],
  employmentTypes: [],
  education: [],
  housingTypes: [],
  occupationsByEmploymentType: {},
  stayDurations: [],
  loanRanges: [],
})
